import { Button } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { FiMessageSquare } from "react-icons/fi";
import { useOptionalAssistantContext } from "./AssistantProvider";
import { useWizardStep } from "./pageEntityNames";
import { useAssistantEntry } from "./useAssistantEntry";

export const HelpWithStepButton = () => {
  const { t } = useTranslation();
  const open = useAssistantEntry();
  const assistant = useOptionalAssistantContext();
  const [asked, setAsked] = useState(false);
  const leftOpenConversation = useRef(false);
  const request = t("Help me with this step.") ?? "";
  const label = t("Help me with this step") ?? undefined;
  const step = useWizardStep(useParams().eventId);
  const title = step ? t("Help me with the step «{{step}}»", { step: step.label }) : label;

  useEffect(() => {
    if (!asked || !assistant?.toolsSettled || assistant.isRunning || assistant.isRestoring) return;
    if (assistant.turns.length > 0) {
      if (!leftOpenConversation.current) {
        leftOpenConversation.current = true;
        assistant.startNew();
      }
      return;
    }
    leftOpenConversation.current = false;
    setAsked(false);
    if (!assistant.toolsReady) return;
    assistant.bindToPage();
    void assistant.send(request, title);
  }, [asked, assistant, request, title]);

  if (!open || !assistant || assistant.assistantNotIncluded || assistant.aiNotAllowed) return null;
  const askForHelp = () => {
    open();
    setAsked(true);
  };
  return (
    <Button
      leftIcon={<FiMessageSquare />}
      variant="outline"
      colorScheme="teal"
      size="sm"
      isDisabled={asked || assistant.isRunning || assistant.toolsLoading}
      onClick={askForHelp}
    >
      {label}
    </Button>
  );
};
